

function SelectComponent({className='', options=[], selectedOption, onChange=()=>{}}) {
  if(options.length < 1) throw new Error('Error: SelectComponent requires at least 1 option')
  selectedOption = selectedOption || options[0]
  var div = document.createElement('div')
  div.className = `select-component ${className}`
  var label = document.createElement('div')
  label.className = 'label'
  label.innerHTML = selectedOption
  var select = document.createElement('select')
  var chevron = document.createElement('div')
  chevron.className = 'chevron'
  chevron.innerHTML = `
    <svg width="8" height="5" viewBox="0 0 8 5" fill="none" xmlns="http://www.w3.org/2000/svg">
      <line x1="0.353553" y1="0.646447" x2="4.35355" y2="4.64645" stroke="black"/>
      <line x1="3.64645" y1="4.64645" x2="7.64645" y2="0.646447" stroke="black"/>
    </svg>
  `
  div.appendChild(label)
  if(options.length > 1) div.appendChild(chevron)
  if(options.length > 1) div.appendChild(select)
  options.forEach(option => {
    var optionNode = document.createElement('option')
    optionNode.value = option
    optionNode.innerHTML = option
    select.appendChild(optionNode)
  })
  select.onchange = (event) => {
    const value = options[select.selectedIndex]
    onChange(select.selectedIndex, value, this, event)
    label.innerHTML = value
  }
  return div
}
